export const NonEmptyString = (errorMessage: string) => (value: string) =>
    !!value || errorMessage;

export const MatchRegex = (regex: RegExp) => (errorMessage: string) => (value: string) =>
    Boolean(value.match(regex)) || errorMessage;

export const MinLength = (minLength: number, errorMessage: string) => (value: string) =>
    value.length >= minLength || errorMessage;

export const MaxLength = (maxLength: number, errorMessage: string) => (value: string) =>
    value.length <= maxLength || errorMessage;

export const AtLeastOneLowercaseCharacter = MatchRegex(/.*[a-zа-я].*/);
export const AtLeastOneUppercaseCharacter = MatchRegex(/.*[A-ZА-Я].*/);
export const AtLeastOneNumericCharacter = MatchRegex(/.*[0-9].*/);
export const NoBackslash = MatchRegex(/^[^\\]*$/);
